import styled from 'styled-components';
import { Link } from '@material-ui/core';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import { SPACES } from 'common/constants/sizes';
import svgLogo from 'images/logos/linearb-logo.svg';
import SlackConnectedSuccessfullyBackground from 'images/characters/character-slack-connected-successfully.svg';
import PurpleDude from 'images/characters/purple-dude.svg';
import SpeechBalloon from 'images/characters/speech-balloon.svg';
import { useHistory } from 'react-router';
import workerbJiraLogo from 'images/logos/workerb-jira-logo.svg';
import AppRouter from 'common/AppRouter';
import { LBButton } from '@linearb/buzz';

const LinearbLogo = styled.img`
  width: 10rem;
  padding-top: ${SPACES['x-big']};
`;

const WorkerbJiraLogo = styled.img`
  width: 9rem;
  padding-top: ${SPACES['large']};
`;

const SpeechBalloonBox = styled(Flex)`
  justify-content: center;
  align-items: center;
  border: 0 solid red;
  width: 14rem;
  height: 6rem;
  background: url(${SpeechBalloon}) no-repeat left center;
  background-size: contain;
  position: absolute;
  right: 28%;
  bottom: 16%;
`;

const LinkAccountDoneWrapper = styled(Flex)`
  ${({ hasAccount }) =>
    `background: url(${
      hasAccount ? SlackConnectedSuccessfullyBackground : PurpleDude
    }) no-repeat center bottom;
    background-size: ${hasAccount ? '32rem' : '8rem'}`};
`;

const redirectToSlack = () => {
  window.location.replace('slack://open');
};

const LinkAccountDoneModalJira = () => {
  const history = useHistory();
  return (
    <LinkAccountDoneWrapper direction='column' height='100%'>
      <Flex direction='column' items='center' grow='1' height='100%'>
        <LinearbLogo src={svgLogo} />

        <WorkerbJiraLogo src={workerbJiraLogo} />
        <Text size='x-x-x-large' weight='300' pt='2rem' color='black'>
          You've connected Jira to WorkerB!
        </Text>
        <Text size='large' pt='1rem' color='black'>
          You can now create new Jira tickets from Slack with one click!
        </Text>
        <Text pt='3rem'>
          <LBButton onClick={redirectToSlack}>Back to Slack</LBButton>
        </Text>
      </Flex>
      <SpeechBalloonBox>
        <Text size='small' ml='1rem'>
          Visit{' '}
          <Link
            onClick={() => {
              window.open('https://linearb.io/');
            }}
          >
            LinearB.io
          </Link>
          <br />
          to learn more about us
        </Text>
      </SpeechBalloonBox>
      <Flex padding='normal'>
        <Text size='medium'>
          <Link onClick={() => history.push(AppRouter.LOGIN.path)}>
            &lt; back to login
          </Link>
        </Text>
      </Flex>
    </LinkAccountDoneWrapper>
  );
};
export default LinkAccountDoneModalJira;
